import { SingleSelectField } from "@dgs/core";
import { useField } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { ContactFilterAttributeType, ContactFilterOperator } from "../shared/types";

interface Props2 {
	type: ContactFilterAttributeType;
	name: string;
	operators: ContactFilterOperator[];
}

export const ContactFilterOperatorSelect: FC<Props2> = ({ type, name, operators }) => {
	const { t } = useTranslation();
	const [, , { setValue }] = useField(`${name}.value`);

	return (
		<SingleSelectField<ContactFilterOperator, ContactFilterOperator>
			options={operators}
			label={t("Operator")}
			placeholder={t("Operator")}
			name={`${name}.operator`}
			getLabel={(option) => t(option)}
			clearable={false}
			onChange={(e) => {
				void setValue(e.target.value === "EQUAL" && type === "checkbox" ? false : null);
			}}
		/>
	);
};
